/**
 * 스마트 안전장비 — 산업안전보건관리비(안전시설비) 인정 안내 (공통)
 */

export const SMART_EQUIPMENT_COST_LINKS = [
  {
    label: '고시 나목 — 스마트안전장비(안전시설비)',
    url: '/safety-regulations/qa-construction/intro#intro-na-2',
  },
  {
    label: '건설기술진흥법 제62조의3 — 보조·지원',
    url: '/safety-regulations/001807/article/62-3',
  },
  {
    label: '시행령 제101조의7 — 지원 대상',
    url: '/safety-regulations/002111/article/101-7',
  },
];

const BASE = {
  summary: '스마트안전장비로 확인되면 안전시설비(산업안전보건관리비)로 구입·임대비를 쓸 수 있습니다.',
  bullets: [
    '2025.1.1~ 구입·임대비의 70% 인정',
    '2026.1.1~ 구입·임대비의 100% 인정',
    '총액의 10분의 2(20%)를 초과할 수 없음',
  ],
  confirmNote: '품목·성능별 해당 여부 → 국토안전관리원·고용노동부 등 공식 확인',
  supportNote: '국고 보조·지원은 「건설기술진흥법」 제62조의3도 함께 검토',
};

/** @param {{ extraNote?: string, links?: Array<{label:string,url:string}> }} [overrides] */
export function buildSmartEquipmentManagementCost(overrides = {}) {
  return {
    recognized: true,
    limitedRecognition: true,
    category: '안전시설비 · 스마트안전장비',
    summary: BASE.summary,
    bullets: BASE.bullets,
    confirmNote: BASE.confirmNote,
    supportNote: BASE.supportNote,
    extraNote: overrides.extraNote || null,
    links: overrides.links || SMART_EQUIPMENT_COST_LINKS,
  };
}

export const SMART_ITEM_COST_OVERRIDES = {
  smartAirbagVest: {
    extraNote: '에어백 조끼는 질의회시에서 품목별 해당 여부를 확인합니다.',
    links: [
      ...SMART_EQUIPMENT_COST_LINKS,
      {
        label: '질의회시 1-1-43 — 에어백 조끼',
        url: '/safety-regulations/qa-construction/chapter1/section1/43',
      },
    ],
  },
  workerWearableSmart: {
    extraNote: '스마트 헬멧·통신조끼는 구입비와 통신·구독료를 구분해 확인하세요.',
    links: [
      ...SMART_EQUIPMENT_COST_LINKS,
      {
        label: '질의회시 1-1-44 — 착용형·솔루션',
        url: '/safety-regulations/qa-construction/chapter1/section1/44',
      },
    ],
  },
  gasDetection: {
    links: [
      ...SMART_EQUIPMENT_COST_LINKS,
      {
        label: '질의회시 1-1-46 — 유해가스 모니터링',
        url: '/safety-regulations/qa-construction/chapter1/section1/46',
      },
    ],
  },
};
